(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["swimdays-home-header"] && !Shopify.designMode) return;
  try {
    (() => {
    // This header replaces Atelier's stock one, so its <cart-icon> element -- the thing
    // that normally live-updates the count -- never renders. Mirror cart:update here so
    // the badge responds to an add instead of waiting for a full page load.
    const initSwimdaysCartCount = () => {
      if (document.documentElement.dataset.swimdaysCartCountInit === 'true') return;
      document.documentElement.dataset.swimdaysCartCountInit = 'true';

      const render = (count) => {
        document.querySelectorAll('[data-swimdays-cart-link]').forEach((link) => {
          link.setAttribute('aria-label', `Cart with ${count} items`);

          const badge = link.querySelector('[data-swimdays-cart-count]');
          if (!badge) return;

          badge.textContent = count > 99 ? '99+' : String(count);
          badge.toggleAttribute('hidden', count === 0);
        });
      };

      const readCount = () => {
        const badge = document.querySelector('[data-swimdays-cart-count]');
        if (!badge || badge.hasAttribute('hidden')) return 0;

        return parseInt(badge.textContent, 10) || 0;
      };

      let reconcileTimer;

      const reconcile = () => {
        window.clearTimeout(reconcileTimer);

        reconcileTimer = window.setTimeout(() => {
          const cartUrl = (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_url) || '/cart';

          fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } })
            .then((response) => (response.ok ? response.json() : null))
            .then((cart) => {
              if (cart && typeof cart.item_count === 'number') render(cart.item_count);
            })
            .catch(() => {
              // Keep the optimistic count if the cart cannot be re-read.
            });
        }, 250);
      };

      document.addEventListener('cart:update', (event) => {
        const data = event.detail && event.detail.data;
        const itemCount = Number(data && data.itemCount);

        // A product form reports the quantity it just added; every other source reports the new total.
        if (data && !data.didError && Number.isFinite(itemCount)) {
          render(data.source === 'product-form-component' ? readCount() + itemCount : itemCount);
        }

        reconcile();
      });

      window.addEventListener('pageshow', (event) => {
        if (event.persisted) reconcile();
      });
    };

    const initSwimdaysHomeHeader = (root = document) => {
      const headerWrappers = root.querySelectorAll('.swimdays-home-header');

      headerWrappers.forEach((wrapper) => {
        const navbar = wrapper.querySelector('.swimdays-navbar');
        if (!navbar || navbar.dataset.swimdaysHeaderInit === 'true') return;

        navbar.dataset.swimdaysHeaderInit = 'true';

        const announcementTrigger = document.querySelector('#brand-statement');
        const menuToggle = wrapper.querySelector('.navbar-toggle');
        const menuClose = wrapper.querySelector('.mobile-menu-close');
        const mobileMenu = wrapper.querySelector('.mobile-menu');
        const mobileMenuLinks = wrapper.querySelectorAll('.mobile-menu a');
        const desktopViewport = window.matchMedia('(min-width: 960px)');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const announcementCarousel = wrapper.querySelector('[data-swimdays-announcement-carousel]');

        const setMenuState = (isOpen) => {
          navbar.classList.toggle('menu-open', isOpen);
          document.body.classList.toggle('nav-locked', isOpen);
          if (menuToggle) menuToggle.setAttribute('aria-expanded', String(isOpen));
          if (mobileMenu) {
            mobileMenu.setAttribute('aria-hidden', String(!isOpen));

            if (isOpen) {
              mobileMenu.removeAttribute('inert');
            } else {
              mobileMenu.setAttribute('inert', '');
            }
          }
        };

        const shouldHideAnnouncement = () => {
          if (announcementTrigger) {
            const triggerTop = announcementTrigger.getBoundingClientRect().top;
            const hideThreshold = window.innerHeight * 0.82;
            return triggerTop <= hideThreshold;
          }

          return window.scrollY > 72;
        };

        const applyScrollState = () => {
          navbar.classList.toggle('is-scrolled', window.scrollY > 20);
          document.body.classList.toggle('announcement-hidden', shouldHideAnnouncement());
        };

        const initAnnouncementCarousel = () => {
          if (!announcementCarousel || announcementCarousel.dataset.announcementInit === 'true') return;

          const slides = Array.from(announcementCarousel.querySelectorAll('[data-announcement-slide]'));
          if (slides.length < 2) return;

          announcementCarousel.dataset.announcementInit = 'true';

          const prevBtn = announcementCarousel.querySelector('[data-announcement-prev]');
          const nextBtn = announcementCarousel.querySelector('[data-announcement-next]');
          let currentIndex = 0;
          let intervalId;

          const setSlide = (nextIndex, { animate = true } = {}) => {
            const previousIndex = currentIndex;
            const resolvedIndex = ((nextIndex % slides.length) + slides.length) % slides.length;

            if (resolvedIndex === previousIndex && animate) return;

            currentIndex = resolvedIndex;

            slides.forEach((slide, index) => {
              const isActive = index === currentIndex;
              const isLeaving = animate && index === previousIndex;

              if (isLeaving) {
                // Add leaving before removing active so the exit goes up, not down.
                slide.classList.add('is-leaving');
                slide.classList.remove('is-active', 'is-instant');

                const clearLeaving = (event) => {
                  if (event.propertyName !== 'transform' && event.propertyName !== 'opacity') return;
                  slide.removeEventListener('transitionend', clearLeaving);
                  slide.classList.add('is-instant');
                  slide.classList.remove('is-leaving');
                  void slide.offsetWidth;
                  slide.classList.remove('is-instant');
                };
                slide.addEventListener('transitionend', clearLeaving);
              } else if (isActive) {
                slide.classList.remove('is-leaving', 'is-instant');
                slide.classList.add('is-active');
              } else {
                slide.classList.remove('is-active', 'is-leaving', 'is-instant');
              }

              slide.setAttribute('aria-hidden', String(!isActive));
              slide.toggleAttribute('inert', !isActive);
            });
          };

          const stopCarousel = () => {
            window.clearInterval(intervalId);
            intervalId = undefined;
          };

          const startCarousel = () => {
            stopCarousel();
            if (reducedMotion.matches || document.hidden) return;

            intervalId = window.setInterval(() => {
              setSlide(currentIndex + 1);
            }, 9000);
          };

          const goTo = (nextIndex) => {
            setSlide(nextIndex);
            startCarousel();
          };

          prevBtn?.addEventListener('click', () => goTo(currentIndex - 1));
          nextBtn?.addEventListener('click', () => goTo(currentIndex + 1));

          announcementCarousel.addEventListener('mouseenter', stopCarousel);
          announcementCarousel.addEventListener('mouseleave', startCarousel);
          announcementCarousel.addEventListener('focusin', stopCarousel);
          announcementCarousel.addEventListener('focusout', startCarousel);
          reducedMotion.addEventListener('change', startCarousel);
          document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
              stopCarousel();
            } else {
              startCarousel();
            }
          });

          setSlide(0, { animate: false });
          startCarousel();
        };

        menuToggle?.addEventListener('click', () => setMenuState(true));
        menuClose?.addEventListener('click', () => setMenuState(false));
        mobileMenu?.addEventListener('click', (event) => {
          if (event.target === mobileMenu) setMenuState(false);
        });
        mobileMenuLinks.forEach((link) => link.addEventListener('click', () => setMenuState(false)));
        desktopViewport.addEventListener('change', (event) => {
          if (event.matches) setMenuState(false);
        });

        window.addEventListener('scroll', applyScrollState, { passive: true });
        window.addEventListener('resize', applyScrollState);
        applyScrollState();
        initAnnouncementCarousel();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initSwimdaysCartCount();
        initSwimdaysHomeHeader();
      });
    } else {
      initSwimdaysCartCount();
      initSwimdaysHomeHeader();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initSwimdaysHomeHeader(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
